import { render, staticRenderFns } from "./PostbackSingle.vue?vue&type=template&id=44f934e3&scoped=true&"
import script from "./PostbackSingle.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PostbackSingle.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PostbackSingle.vue?vue&type=style&index=0&id=44f934e3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f934e3",
  null
  
)

export default component.exports